import React from 'react'
import clsx from 'clsx'

const simple = 'appearance-none w-full text-2xl p-2 border border-gray-300 disabled:bg-white disabled:text-grey-400'
export const Input = ({ className, leadingOpen, trailingButton, forwardRef, ...props }) => {
  return (
    <input
      className={clsx(
        className,
        simple,
        trailingButton && 'border-r-0 rounded-l flex-1 min-w-0',
        leadingOpen && 'border-l-0 rounded-r flex-1 min-w-0 pl-0',
        !trailingButton && !leadingOpen && 'rounded',
        props.disabled && 'disabled'
      )}
      ref={forwardRef}
      {...props}
    />
  )
}

export default Input
